import { findRecord } from "./services";

async function getProfileInfo(userId) {
  let data = await findRecord("users", {
    conditions: `id/=/${userId}`,
    fields: "mobile, fname, lname, fathername, username, codemelli, provinceid, cityid, bdyear, bdmonth, bdday, tell, email, jender, address, profilepic, mtm, isadmin, mainstatus, user_admin_group",
  });
  if (data.length == 0) return false;
  data = {
    ...data[0],
    city: {
      id: data.cityid,
      title: "",
      provinceid: "",
    },
    province: {
      id: data.provinceid,
      title: "",
    },
  };
  if (data.cityid != 0) {
    let city = await findRecord("cities", {
      conditions: `id/=/${data.cityid}`,
    });
    if (city.length > 0) {
      data.city = city[0];
    }
  }
  if (data.provinceid != 0) {
    if (data.provinceid != data.city.provinceid) console.log("Warning: province that sets in city table is not equal to province sets in users table");
    let provinceid = data.provinceid;
    if (data.city.provinceid != "") provinceid = data.city.provinceid;
    let province = await findRecord("provinces", {
      conditions: `id/=/${provinceid}`,
    });
    if (province.length > 0) {
      data.province = province[0];
    }
  }
  return data;
}

async function getVisits(userId) {
  let data = findRecord("visits", {
    conditions: `uid/=/${userId}`,
    fields: "title, route, mtm",
  });
  if (data == 0) return false;
  return data;
}

export { getProfileInfo, getVisits };
